module.exports = __webpack_public_path__ + "img/kefu2.022b6256.png";